import { render } from "./Process.vue?vue&type=template&id=1cc4a77f&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"

import "./Process.vue?vue&type=style&index=0&id=1cc4a77f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1cc4a77f"

export default script